const setFilter = () => {
  let controller;
  if (controller) {
    controller.abort();
  }
  controller = new AbortController();
  const signal = controller.signal;
  const queryText = "/search?q=%26&options%5Bprefix%5D=last";
  fetch(queryText, { signal })
    .then((response) => response.text())
    .then((data) => {
      console.log("1");
      let parser = new DOMParser();
      let doc = parser.parseFromString(data, "text/html");
      let filters = doc.querySelector("#filterObject");
      
      // ここでクラス名を変更します
      const elementsToChange = filters.querySelectorAll(".pre__filter");
      elementsToChange.forEach(element => {
        element.classList.remove("pre__filter");
        element.classList.add("ds__filter");
      });
      console.log(`${elementsToChange.length} elements have been updated.`);
      
      const preSearchResult = document.querySelector("#filterObject--target");
      if (preSearchResult) {
        preSearchResult.insertAdjacentHTML("afterend", filters.innerHTML);
    
        // 新しい要素がDOMに追加されたので、カスタムイベントをトリガーします
        const filterUpdateEvent = new Event("filterUpdate");
        document.dispatchEvent(filterUpdateEvent);
      }
    })
    
    .catch((error) => {
      if (error.name === "AbortError") {
        console.log("Fetch aborted");
      } else {
        console.error("Error:", error);
      }
    });
};
setFilter();

/*
  ヘッダーからの呼び出し
  collectionページでの絞り込み
  searchでの絞り込み
  */

// 検索モーダルのキーワード入力欄の取得
const searchFilterFormKeywords = document.querySelectorAll(
  ".ds2 .search__input"
);

// ヘッダー検索ボタンからの呼び出し（キーワード入力欄付きでモーダル表示）
const showSearchFilterModalFromHeader = () => {
  searchFilterFormKeywords.forEach((searchFilterFormKeyword) => {
    searchFilterFormKeyword.style.display = "block";
  });
  // スクロールポジションを直す
  document.querySelector("#search-filter-form dl").scrollTop = 0;
  // 検索条件を全てリセット
  // resetSearchConditions();
  // モーダルのタイトルを書き換え
  document.querySelector(".search-filter-title").textContent = "商品検索";
  // モーダル表示
  showSearchFilterModal();
};
// 絞り込みボタンからの呼び出し（キーワード入力欄無しでモーダル表示）
const showSearchFilterModalFromButton = () => {
  // パラメータとhandleから検索条件を初期化
  initializeConditionsFromParamsAndHandle();
  // プレ検索を実行
  setTimeout(preSearch, 0);
  // モーダル表示
  showSearchFilterModal();
};
// モーダルウィンドウの表示・非表示
const searchFilterWrapper = document.querySelector("#search-filter-wrapper");
const searchFilterOverlay = document.querySelector("#search-filter-overlay");
const body = document.querySelector("body");
const showSearchFilterModal = () => {
  if (window.outerWidth > 767) {
    searchFilterWrapper.classList.add("is-show");
    searchFilterOverlay.classList.add("is-show");
  } else {
    searchFilterWrapper.classList.toggle("active");
  }
  body.style.overflow = "hidden"; //モーダル表示中は下の画面のスクロールを停止

  // 検索項目のアコーディオン設定
  closeFilterItem();
};
const hideSearchFilterModal = (e) => {
  e.preventDefault();
  if (window.outerWidth > 767) {
    searchFilterWrapper.classList.remove("is-show");
    searchFilterOverlay.classList.remove("is-show");
  } else {
    searchFilterWrapper.classList.toggle("active");
  }
  body.style.overflow = "visible";
};

// パラメータとhandleから検索条件を初期化
const initializeConditionsFromParamsAndHandle = () => {
  const params = new URLSearchParams(window.location.search);
  for (const [key, value] of params) {
    console.log('key:'+ key);
    if (key == "q") {
      // 検索ワードの設定
      const searchWord = document.querySelector(".ds2 .search__input");
      if (searchWord && value != '&') {
        searchWord.value = value;
      }
    } else {
      // 検索項目の設定
      let checkboxes = document.querySelectorAll(`.ds2 [type="checkbox"][name="${key}"]`);
      if (checkboxes.length) {
        console.log('checkboxes:', checkboxes);

        for (const checkbox of checkboxes) {
          console.log('checkbox.value:', checkbox.value);

          if (checkbox.value == value) {
            checkbox.checked = true;
          }
        }
      } else {
        console.log('No checkboxes found');
      }

    }
  }
  // let checkboxs;
  //
};

// 検索条件を全てリセット
const resetSearchConditions = () => {
  setTimeout(preSearch, 0);
};

// 検索項目のアコーディオンをリセット（3行分まで表示して矢印を表示）
const closeFilterItem = () => {
  var listItem = document.querySelectorAll("#search-filter-form dd ul li");
  if (listItem.length > 0) {
    if (window.outerWidth > 767) {
      var listShowHeight = (listItem[0].offsetHeight + 10) * 3;
    } else {
      var listShowHeight = (listItem[0].offsetHeight + 5) * 4;
    }
    document
      .querySelectorAll("#search-filter-form dd ul")
      .forEach(function (element) {
        if (
          !element.classList.contains("search-filter-color") &&
          element.offsetHeight > listShowHeight
        ) {
          //カラーカテゴリーはアコーディオンにせず全部表示
          element.classList.add("narrow");
          element.style.height = listShowHeight + "px";
          var nextElement = element.nextElementSibling;
          if (nextElement) {
            nextElement.style.display = "block";
          }
        }
      });
  }
};
// 検索項目のアコーディオンを開く
const openFIlterItem = (element) => {
  var previousElement = element.previousElementSibling;
  if (previousElement) {
    previousElement.classList.remove("narrow");
    previousElement.style.height = "auto";
  }
  element.style.display = "none";
};

// 設定された検索条件からクエリ文字列を生成して返す
const getQueryStringFromConditions = () => {
  let filterQueryString = "";
  const serachWord = document.querySelector(".ds2 .search__input");
  if (serachWord) {
    if (serachWord.value != "")
      filterQueryString += "q=" + serachWord.value + "&type=product";
  }
  const checkedItems = document.querySelectorAll(".ds__filter:checked,.pliceLower.ds__filter,.priceUpper.ds__filter");
  const selectedFiltersElement = document.querySelector("#selected-filters");
  selectedFiltersElement.innerHTML = "";

  checkedItems.forEach((item) => {
    if (filterQueryString != "") filterQueryString += "&";
    filterQueryString += item.name + "=" + encodeURIComponent(item.value);

    // タグを1つずつ格納
    const selectedItemElement = document.createElement("div");
    selectedItemElement.classList.add("selected-item");
    if (item.name === "filter.v.availability") {
      selectedItemElement.textContent = item.nextElementSibling.textContent;
      selectedItemElement.classList.add("selected-item--availability");
    } else {
      selectedItemElement.textContent = item.value;
    }

    // タグクリックで削除&選択解除
    selectedItemElement.addEventListener("click", () => {
      console.log(event.target);
      if (event.target.classList.contains("selected-item--availability")) {
        const selectedItemText = event.target.textContent;

        // labelのテキストを基にチェックボックスを検索
        const checkedItem = Array.from(
          document.querySelectorAll(".ds__filter")
        ).find((i) => {
          const label = i.nextElementSibling;
          return label && label.textContent === selectedItemText;
        });

        if (checkedItem) {
          checkedItem.checked = false; // チェックを外す
        }

        event.target.remove(); // 要素を削除
        return; // ここで関数から退出
      } else if (event.target.classList.contains("selected-item")) {
        console.log("test2");
        const selectedItemText = event.target.textContent;

        let checkedItem = document.querySelector(
          `.ds__filter[value="${selectedItemText}"]`
        );

        if (checkedItem) {
          checkedItem.checked = false; // チェックを外す
        } else {
        }

        event.target.remove(); // 要素を削除
      }
    });

    selectedFiltersElement.appendChild(selectedItemElement);
  });

  return filterQueryString;
};

// 実行前検索（絞り込みを行う前に件数確認）
let controller;
const preSearch = () => {
  if (controller) {
    controller.abort();
  }
  controller = new AbortController();
  const signal = controller.signal;

  const serachWord = document.querySelector(".ds2 .search__input");
  const queryText =
    (serachWord.value != "" ? "/search?" : "/collections/all?") +
    getQueryStringFromConditions();

  const preSearchResult = document.querySelector("#pre-search-result");
  preSearchResult.innerHTML = `取得中...`;
  console.log(queryText);

  fetch(queryText, { signal })
    .then((response) => response.text())
    .then((data) => {
      let parser = new DOMParser();
      let doc = parser.parseFromString(data, "text/html");
      console.log();
      let productCounts = doc.querySelector("input#products-counts")?.value;
      console.log(productCounts);

      productCounts =
        "<small>検索結果</small><strong>" + productCounts + "件</strong><span>の商品があります</span>";
      const preSearchResult = document.querySelector("#pre-search-result");
      if (preSearchResult) {
        preSearchResult.innerHTML = productCounts;
      } else {
        console.error("#pre-search-result element not found");
      }
    })
    .catch((error) => {
      if (error.name === "AbortError") {
        console.log("Fetch aborted");
      } else {
        console.error("Error:", error);
      }
    });
};

// フィルター検索を実行
// 検索条件から生成されたクエリを付与してallコレクションをフィルタリング
const filterSearch = (e) => {
  e.preventDefault();
  const serachWord = document.querySelector(".ds2 .search__input");
  const queryText =
    (serachWord.value != "" ? "/search?" : "/collections/all?") +
    getQueryStringFromConditions();
  location.href = queryText;
};

// タグクリックでもう一度件数取得
document.addEventListener("click", function (event) {
  if (event.target.classList.contains("selected-item")) {
    preSearch();
  }
});
document.addEventListener("filterUpdate", () => {

  // 検索モーダルを閉じる
  const modalClose = document.querySelectorAll('#sds__modal--bg');
  modalClose.forEach((modalClose) => {
    modalClose.addEventListener('click', () => {
      document.querySelector('#sds__modal--bg').classList.remove('show');
        document.querySelector('#sds__modal').classList.remove('show');
        event.preventDefault(); // return false の代わり
    });
  });

  // 検索モーダルを開く
  const modalOpen = document.querySelectorAll('.sds__modal--open');
  modalOpen.forEach((modalOpen) => {
    modalOpen.addEventListener('click', () => {
      document.querySelector('#sds__modal--bg').classList.add('show');
      document.querySelector('#sds__modal').classList.add('show');

      // パラメータとhandleから検索条件を初期化
      initializeConditionsFromParamsAndHandle();
      // プレ検索を実行
      setTimeout(preSearch, 0);

      event.preventDefault(); // return false の代わり
    });
  });
  
  // ヘッダー右上の検索ボタンのクリックイベント
  // const openHeaderFilterModal = document.querySelector('#open-header-filter-modal');
  // openHeaderFilterModal.addEventListener('click', showSearchFilterModalFromHeader);

  // 詳しく絞り込むボタンのクリックイベント
  // if (document.querySelector('#open-filter-modal')) {
  //     const openFilterModal = document.querySelector('#open-filter-modal');
  //     openFilterModal.addEventListener('click', showSearchFilterModalFromButton);
  // }

  // モーダル「閉じる」ボタンのクリックイベント
  document
    .querySelector("#close-filter-modal")
    ?.addEventListener("click", hideSearchFilterModal);

  // モーダル背景のクリックイベント
  document
    .querySelector("#search-filter-overlay")
    ?.addEventListener("click", hideSearchFilterModal);

  // 検索項目の矢印のクリックイベント
  const openSearchItems = document.querySelectorAll(".search-filter-arrow");
  openSearchItems.forEach((element) => {
    element.addEventListener("click", () => {
      openFIlterItem(element);
    });
  });

  // リセットボタンのクリックイベント
  const searchReset = document.querySelector(".sds__clear.button");
  searchReset.addEventListener("click", resetSearchConditions);

  // 検索項目にプレ検索イベントを設定
  const serachWord = document.querySelector(".ds2 .search__input");
  if (serachWord) {
    serachWord.addEventListener("input", preSearch);
    // エンターキー押下で検索実行
    serachWord.addEventListener("keydown", (e) => {
      if (e.keyCode === 13) {
        e.preventDefault();
        filterSearch(e);
      }
    });
  }
  const searchFilterConditions = document.querySelectorAll(".ds__filter");
  searchFilterConditions.forEach((condition) => {
    condition.addEventListener("change", preSearch);
  });

  // 検索ボタンのクリックイベント
  const subSearchButton = document.querySelector("#sub-search-submit");
  if (subSearchButton) subSearchButton.addEventListener("click", filterSearch);
  const searchButton = document.querySelector("#search-submit");
  if (searchButton) searchButton.addEventListener("click", filterSearch);

  // 検索項目のアコーディオン
  document.addEventListener("click", function (e) {
    if (e.target.matches(".sds__title")) {
      let nextElement = e.target.nextElementSibling;
      if (nextElement) {
        if (nextElement.style.maxHeight) {
          nextElement.style.maxHeight = null;
          nextElement.style.overflow = "hidden";
          e.target.classList.remove("show");
          nextElement.style.transition = "max-height 0.4s ease";
        } else {
          nextElement.style.maxHeight = nextElement.scrollHeight + 2 + "px";
          nextElement.style.overflow = "hidden";
          e.target.classList.add("show");
          nextElement.style.transition = "max-height 0.4s ease";
        }
      }
      e.preventDefault();
    }
  });
});
